// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

interface NotificationBadgeProps {
  value: number | string;
}
export const NotificationBadge: React.FC<NotificationBadgeProps> = ({ value }) => {
  if (value === 0) {
    return null;
  }
  if (typeof value === 'string') {
    return <Chip color="primary" size="small" label={value} />;
  }
  return (
    <Box
      sx={{
        height: 20,
        width: 20,
        ml: 1,
        borderRadius: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: (t) => t.palette.primary.main,
      }}
    >
      <Typography
        sx={{ color: (t) => t.palette.getContrastText(t.palette.primary.main) }}
        variant="caption"
      >
        {value}
      </Typography>
    </Box>
  );
};
